import './StatusHoldReleaseForm.scss'

import React, {Component} from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { createStructuredSelector } from 'reselect'
import { scrollToTop } from 'manager/util/helper'
import FeedbackFormField from 'common/views/components/FormField'
import OpCheckbox from 'common/views/components/OpCheckbox'
import {
  TRANSACTION_TYPE,
  OFFENSIVE_REASONS_TEXT,
  RELEASE_REASONS_FOLLOW_UP,
  HIGH_LEVEL_RELEASE_REASON,
  LOW_LEVEL_RELEASE_REASON,
  RELEASE_REASONS_TITLE,
  ANDROID,
} from 'common/constants'
import {
  updateReleaseReason,
  updateNote,
  saveStatus,
  fetchAssignmentTransactions,
  updateReleaseReasonHighLevel,
  updateReleaseNumTimesContacted,
} from 'manager/redux/referral_status'
import { StatusSubmitButton } from './StatusSubmitButton'
import { labelFor, wordForNumber } from 'common/util/helper'
import {
  selectNote,
  selectReleaseReason,
  selectTransactionCount,
  selectReleaseReasonHighLevel,
  selectReleaseHighLevelOptions,
  selectReleaseLowLevelOptions,
  selectReleaseFeedbackLabel,
  selectReleaseSubmitDisabled,
  selectReleaseIsLostContact,
  selectReleaseShouldShowNoteAndReconnect,
  selectReleaseShowMultiWarning,
} from 'manager/selectors/referral_status_selectors'
import { selectAssignmentHash, selectTransactionType } from 'manager/selectors/referral_selectors'
import { isEmbedded, deviceType } from 'common/util/features'
import _ from 'lodash'

export const MultipleTransactionWarning = ({ transactionCount, transactionType }) => {
  return <div className="StatusHoldReleaseForm__warning">We have created {wordForNumber(transactionCount)} leads in the Referral Manager to separately track the transactions for this client. You are only releasing one <b>{labelFor(TRANSACTION_TYPE, transactionType)}</b> lead.</div>
}

export const SingleSquare = ({ selected, label, onClick, style }) => (
 <button
    className={selected ? 'StatusHoldReleaseForm__low_level_reason__selected_content' : 'StatusHoldReleaseForm__low_level_reason__content'}
    style={style}
    onClick={onClick}>{label}
  </button>
)

export const LowLevelReasons = ({ isLostContact, children }) => <div className='StatusHoldReleaseForm__high_level_reason_container' style={{maxWidth: isLostContact ? '600px' : ''}}>{children}</div>

export const LowLevelReasonTitle = ({ text = '' }) => <div className='StatusHoldReleaseForm__question'>{text}</div>

export const LowLevelReasonFollowUp = ({ followUpText = '' }) => followUpText ? <div className='StatusHoldReleaseForm__follow_up'>{followUpText}</div> : <div/>

export class ReleaseForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isPreventAgentRestore: false,
    }
  }

  componentDidMount = () => {
    const { fetchAssignmentTransactions, assignmentHash } = this.props
    fetchAssignmentTransactions(assignmentHash)
  }

  onSubmit = () => {
    const { release_reason, note, saveStatus } = this.props

    saveStatus({
        action: 'release',
        payload: { release_reason, note, prevent_agent_restore: this.state.isPreventAgentRestore },
    })
  }

  onHighLevelReleaseReasonChange = ({ value }) => {
    const {
      updateReleaseReason,
      updateNote,
      updateReleaseReasonHighLevel,
      updateReleaseNumTimesContacted,
    } = this.props

    updateReleaseReasonHighLevel(value)
    updateReleaseReason(value)
    updateReleaseNumTimesContacted(null)
    updateNote('')
  }

  onLowLevelReasonChange = reason => {
    const { updateReleaseReason, highLevelReleaseReason, updateReleaseNumTimesContacted } = this.props

    if (highLevelReleaseReason === HIGH_LEVEL_RELEASE_REASON.LOST_CONTACT) {
      updateReleaseNumTimesContacted(reason)
      updateReleaseReason(LOW_LEVEL_RELEASE_REASON.LOST_CONTACT)
    } else {
      updateReleaseReason(reason)
    }
  }

  render = () => {
    const {
      release_reason,
      note,
      updateNote,
      transactionCount,
      transactionType,
      highLevelReleaseReason,
      highLevelOptions,
      lowLevelOptions,
      isLostContact,
      feedbackLabel,
      submitDisabled,
      showMultiWarning,
      showNoteAndReconnect,
    } = this.props

    const isSelected = reason => reason === release_reason

    const preventAgentRestore = this.state.isPreventAgentRestore
    
    const useNativeSelect = isEmbedded() && deviceType() == ANDROID

    return <div className='StatusHoldReleaseForm'>
      <div className='StatusHoldReleaseForm__content'>
        <div className='StatusHoldReleaseForm__description'>
          If you are not able to continue working with a referral, we encourage you to release that lead to Realtor.com so that we may assign it to another agent.
        </div>
        { showMultiWarning && <MultipleTransactionWarning transactionCount={transactionCount} transactionType={transactionType} /> }
        <div className="StatusHoldReleaseForm__fields">
          <div style={{ marginBottom: 15 }}>
            <FeedbackFormField className='StatusHoldReleaseForm__select' label='Reason for releasing'>
            { useNativeSelect ? (
                <select className='StatusHoldReleaseForm__select--native' value={highLevelReleaseReason} onChange={({ currentTarget }) => this.onHighLevelReleaseReasonChange({ value: currentTarget && currentTarget.value })}>
                  <option hidden key={-1} value={null}></option>
                  {highLevelOptions.map(({ label, value }) => {
                    return (
                      <option key={value} value={value}>
                        { label }
                      </option>
                    )
                  })}
                </select>
              ) : (
                <Select
                  options={highLevelOptions}
                  value={highLevelReleaseReason}
                  clearable={false}
                  onChange={this.onHighLevelReleaseReasonChange}
                />
            )}
            </FeedbackFormField>
            { !_.isEmpty(lowLevelOptions) &&
              <LowLevelReasons isLostContact={isLostContact}>
                <LowLevelReasonTitle text={RELEASE_REASONS_TITLE[highLevelReleaseReason]} />
                <LowLevelReasonFollowUp followUpText={RELEASE_REASONS_FOLLOW_UP[highLevelReleaseReason]} />
                <div>
                  <div className='StatusHoldReleaseForm__low_level_reason'>
                    { lowLevelOptions.map(reason => (
                      <SingleSquare
                        key={reason}
                        label={OFFENSIVE_REASONS_TEXT[reason]}
                        selected={isSelected(reason)}
                        onClick={() => this.onLowLevelReasonChange(reason)}
                        style={isLostContact ? {width: '75px'} : {}}/>
                    ))}
                  </div>
                </div>
              </LowLevelReasons>
            }
          </div>
          { showNoteAndReconnect &&
            <div>
              <FeedbackFormField className='StatusHoldReleaseForm__textfield' label={feedbackLabel}>
                <textarea className="form-control" onChange={evt => updateNote(evt.target.value)} value={note} onFocus={scrollToTop} />
              </FeedbackFormField>
              <div className='StatusHoldReleaseForm__checkbox'>
                <OpCheckbox 
                  checked={preventAgentRestore}
                  buttonClass="config-option-checkbox"
                  label={`Please do not attempt to reconnect me with this referral`}
                  onChange={() => this.setState({ isPreventAgentRestore: !preventAgentRestore })} />
              </div>
            </div>
          }
        </div>
      </div>
      <StatusSubmitButton
        disabled={submitDisabled}
        onClick={this.onSubmit}>
        Release lead
      </StatusSubmitButton>
    </div>
  }
}

const selector = createStructuredSelector({
  note: selectNote,
  release_reason: selectReleaseReason,
  assignmentHash: selectAssignmentHash,
  transactionType: selectTransactionType,
  transactionCount: selectTransactionCount,
  highLevelOptions: selectReleaseHighLevelOptions,
  lowLevelOptions: selectReleaseLowLevelOptions,
  highLevelReleaseReason: selectReleaseReasonHighLevel,
  isLostContact: selectReleaseIsLostContact,
  feedbackLabel: selectReleaseFeedbackLabel,
  submitDisabled: selectReleaseSubmitDisabled,
  showMultiWarning: selectReleaseShowMultiWarning,
  showNoteAndReconnect: selectReleaseShouldShowNoteAndReconnect,
})

const actions = {
  updateReleaseReason,
  updateNote,
  saveStatus,
  fetchAssignmentTransactions,
  updateReleaseReasonHighLevel,
  updateReleaseNumTimesContacted,
}

export const StatusReleaseForm = connect(selector, actions)(ReleaseForm)
